import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
    CHANGE_INPUT_FILTER_WAREHOUSES: "change_input_filter_warehouses",
    WAREHOUSES_LOADED: "warehouses_loaded",
    SET_FIELD_FORM_WAREHOUSE: "set_field_form_warehouse",
    SET_EDIT_FORM_WAREHOUSE: "set_edit_form_warehouse",
    EDIT_FORM_WAREHOUSE: "edit_form_warehouse",
    RELOAD_INDEX_WAREHOUSES: "reload_index_warehuses"
};

export const INITIAL_STATE = {

    elements: [],
    status: STATUS_NOT_LOADED,
    filter: {
      name: null,
      reference: null,
      limit: 20,
      page: 1,
    },
    rows: 0,
    edit_warehouse: {
      id: 0,
      name: "",
      code: 0,
    },
    for_edit: false,
  
}

export const warehouseReducer = (state, action) => {
    const payload = action.payload;
    const {
      CHANGE_INPUT_FILTER_WAREHOUSES,
      WAREHOUSES_LOADED,
      SET_FIELD_FORM_WAREHOUSE,
      SET_EDIT_FORM_WAREHOUSE,
      EDIT_FORM_WAREHOUSE,
      RELOAD_INDEX_WAREHOUSES,
    } = types;

    switch (action.type) {

        case WAREHOUSES_LOADED:
            return {
              ...state,
              elements: payload.elements,
              rows: payload.rows,
              status: LOADED,
            };

    case CHANGE_INPUT_FILTER_WAREHOUSES:
        return {
            ...state,
            status: STATUS_NOT_LOADED,
                filter: {
                ...state.filter,
                [payload.name]: payload.value,
                },

        };
    case SET_FIELD_FORM_WAREHOUSE:
          return {
              ...state,
              edit_warehouse: {
                  ...state.edit_warehouse,
                  [payload.name]: payload.value,
                  },
  
          };

          case SET_EDIT_FORM_WAREHOUSE:
            return {
                ...state,
                for_edit: payload,
    
            };

            case EDIT_FORM_WAREHOUSE:
              return {
                  ...state,
                  edit_warehouse: payload,
              };

              case RELOAD_INDEX_WAREHOUSES:
                return {
                  ...state,
                  status: STATUS_NOT_LOADED,
              };

        default:
        return state;
    }
}

